import React from "react";
import { FaGlobe } from "react-icons/fa";

const ProjectsCard = ({ title, des, src, link, techStack = [] }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="w-full p-4 xl:px-12 h-full xl:py-10 rounded-lg shadow-shadowOne flex flex-col bg-gradient-to-br from-bodyColor to-[#202327] group hover:bg-gradient-to-tl hover:from-[#1a1d23] hover:to-gray-900 transition-all duration-500 cursor-pointer hover:scale-105 hover:shadow-2xl border border-transparent hover:border-designColor/30"
    >
      {/* Image Container with fixed height */}
      <div className="w-full h-60 overflow-hidden rounded-lg">
        <img
          className="w-full h-full object-cover group-hover:scale-110 duration-300"
          src={src}
          alt="project thumbnail"
        />
      </div>

      {/* Content Container */}
      <div className="flex flex-col flex-grow">
        {/* Title Section */}
        <div className="mt-5">
          <div className="flex items-center justify-between">
            <h3 className="text-base uppercase text-designColor font-normal">
              {title}
            </h3>
            <div className="flex gap-2">
              {/* <FaGlobe className="text-lg w-10 h-10 rounded-full bg-black inline-flex justify-center items-center text-gray-400 hover:text-designColor duration-300" /> */}
            </div>
          </div>
        </div>

        {/* Description Section */}
        <div className="mt-3">
          <p className="text-sm tracking-wide hover:text-gray-100 duration-300">
            {des}
          </p>
        </div>

        {/* Tech Stack Section */}
        {techStack.length > 0 && (
          <div className="mt-4">
            <h4 className="text-sm text-designColor mb-2">Tech Stack:</h4>
            <div className="flex flex-wrap gap-2">
              {techStack.map((tech, index) => (
                <span
                  key={index}
                  className="px-3 py-1 text-xs bg-black rounded-full text-gray-300 hover:text-designColor duration-300"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </a>
  );
};

export default ProjectsCard;
